var map = {
	"./about-1.png": "InIZ",
	"./about-2.png": "B23f",
	"./about-3.png": "24RB",
	"./acc-1.png": "9ug1",
	"./acq-1.png": "LrI/",
	"./acq-2.png": "6QLT",
	"./acq-3.png": "s8xH",
	"./acq-4.png": "q5Qr",
	"./acq-5.png": "Kpiz",
	"./banner-bg.png": "PiNj",
	"./banner-bg2.png": "4EWm",
	"./con-1.png": "uSS2",
	"./con-2.png": "M/Wd",
	"./css/animate.css": "llnD",
	"./css/demo.css": "947H",
	"./css/iconfont": "k86D",
	"./css/iconfont.eot": "nzd/",
	"./css/iconfont.js": "k86D",
	"./css/iconfont.svg": "jLkr",
	"./css/style.css": "VaBq",
	"./font/DIN-Bold.otf": "XQpJ",
	"./font/DINPro-Black.otf": "9JrE",
	"./font/SourceHanSansCN-Bold.otf": "lZDY",
	"./font/SourceHanSansCN-ExtraLight.otf": "aFsi",
	"./font/SourceHanSansCN-Heavy.otf": "Qt9e",
	"./font/SourceHanSansCN-Light.otf": "DZeI",
	"./font/SourceHanSansCN-Medium.otf": "f7ge",
	"./font/SourceHanSansCN-Normal.otf": "oK/C",
	"./font/SourceHanSansCN-Regular.otf": "5kGJ",
	"./font/SourceSansPro-BlackItalic.ttf": "17fH",
	"./font/font.css": "NrZ4",
	"./icon1.png": "HWEK",
	"./icon2.png": "HosE",
	"./icon3.png": "y9FJ",
	"./icon4.png": "K3X3",
	"./icon5.png": "7p1c",
	"./icon6.png": "OAQh",
	"./icon7.png": "xXn4",
	"./loginLeft.png": "hMJZ",
	"./logo.jpg": "4Uwr",
	"./logo.png": "7Otq",
	"./map.png": "/PMo",
	"./news-1.png": "303m",
	"./news-d1.png": "Lgkn",
	"./news-d2.jpg": "Ol0t",
	"./news-d2.mp4": "Oo3r",
	"./news.png": "d/6q",
	"./part1-dis.png": "SEvo",
	"./part1.png": "exEz",
	"./part2-dis.png": "qqY8",
	"./part2.png": "IWxZ",
	"./part3-dis.png": "U3DM",
	"./part3.png": "kEHn",
	"./part4-dis.png": "8Z0y",
	"./part4.png": "CEDY",
	"./payment-1.png": "I1ca",
	"./pic.png": "o3Ya",
	"./pic2.png": "34Bi",
	"./product_bg1.png": "yix7",
	"./product_bg2.png": "8ozt",
	"./sys-1.png": "JW5l",
	"./sys-2.png": "3Mh2",
	"./sys-3.png": "dAxp",
	"./sys-4.png": "sxZV",
	"./sys-5.png": "9Bm4",
	"./tool-1.png": "B+NK",
	"./tool-2.png": "UNaq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1